import React from 'react';
import noScriptImgDev from '../../../../assets/images/project/no-scripts-pic-dev@2x.png';
import noScriptImgTest from '../../../../assets/images/project/no-scripts-pic-test@2x.png';
import noScriptImgProd from '../../../../assets/images/project/no-scripts-pic-prod@2x.png';
import {Environment} from '../../../../const/environment';
import NoContentView from '../../../components/NoContentView/NoContentView';

const images = {
    [Environment.Staging]: noScriptImgDev,
    [Environment.Testing]: noScriptImgTest,
    [Environment.Production]: noScriptImgProd,
};

class ScriptIsUnavailableView extends React.Component {
    render() {
        const { environment, scriptName } = this.props;
        const label = <div>
            Script is unavailable
        </div>;
        return <NoContentView
            className="no-existing-script-view"
            img={images[environment]}
            label={label}
            environment={environment} />;
    }
}

export default ScriptIsUnavailableView;